import React from 'react';

import { Page, LayoutSingleColumn } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';

import ListingConcludedBanner from './ListingConcludedBanner';

import css from './ListingConcludedFallback.module.css';

/**
 * Minimal listing shell when Sharetribe returns 404 but sovereign ledger marks ENDED/ARCHIVED.
 */
const ListingConcludedFallback = props => {
  const { intl, scrollingDisabled, archivedSnapshot, listingLifecycle } = props;
  const title = archivedSnapshot?.title || 'Concluded listing';

  return (
    <Page title={title} scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>
        <div className={css.root}>
          <ListingConcludedBanner lifecycleState={listingLifecycle?.lifecycleState} />
          <h1 className={css.title}>{title}</h1>
          <p className={css.hint}>
            This listing is no longer active on the marketplace feed, but the transaction record
            remains on-chain.
          </p>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

export default ListingConcludedFallback;
